module.exports = __webpack_public_path__ + "img/mobilePhoneGreen.e4397106.png";